export default __webpack_public_path__ + "static/media/Senza Lieviti .947d7640.png";